import { render, staticRenderFns } from "./RegistrationForOfficer.vue?vue&type=template&id=424585e3"
import script from "./RegistrationForOfficer.vue?vue&type=script&lang=js"
export * from "./RegistrationForOfficer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports